import React, { useEffect, ReactNode } from "react"
import WithRouter from "../components/common/WithRouter"

/**
 * Layout de rutas públicas (login). SIEMPRE en tema claro: la página está
 * diseñada light (panel de marca + formulario blanco) y en dark heredado de
 * la sesión el título quedaba ilegible (texto oscuro sobre fondo oscuro).
 *
 * Ojo: el toggle de la app escribe data-bs-theme en <html> (documentElement,
 * slices/layouts/thunk.ts) — la versión anterior de este layout lo escribía
 * en <body>, que el CSS ignora. Al desmontar se restaura el tema previo;
 * además el Layout autenticado re-aplica el modo persistido al entrar.
 */
const NonAuthLayout: React.FC<{
  children: ReactNode
}> = ({ children }) => {
  useEffect(() => {
    const root = document.documentElement
    const previous = root.getAttribute("data-bs-theme")
    root.setAttribute("data-bs-theme", "light")
    document.body.setAttribute("data-bs-theme", "light")
    return () => {
      if (previous) root.setAttribute("data-bs-theme", previous)
      document.body.removeAttribute("data-bs-theme")
    }
  }, [])

  return <div>{children}</div>
}

export default WithRouter(NonAuthLayout)
